import { IPdfData } from './response'

export default async function(response: Response) {
  const json: IPdfData = await response.json()

  return json.items && json.items.length > 0 ? json.items[0].pdf : ''
}
